<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="content video-monitor">
        <div class="leftNav">
          <div class="leftSpot"></div>
          <div class="leftNav_title">
            视频轮播
            <div class="title_btmLine"></div>
          </div>
          <el-input
            placeholder="搜索监控点"
            class="nav-tree-filter"
            v-model="filterText"
          ></el-input>
          <div class="nav-tree-content">
            <el-tree
              style="height:100%;"
              v-loading="loading"
              :element-loading-text="loadingText"
              @node-click="nodeClick"
              :data="nodes"
              node-key="id"
              :props="defaultProps"
              :filter-node-method="filterNode"
              class="zj-demo-player-tree-device-tree"
              ref="tree"
            ></el-tree>
          </div>
        </div>
        <!-- 右侧内容 -->
        <div class="rightContent">
          <div class="topContent">
            <!-- 分屏是一个的时候开始 -->
            <div class="oneVideoBox" v-if="showtype == '1'">
              <div class="showOneVideo">
                <div style="width:100%;height:100%;">
                  <div style="width:100%;height:100%;">
                    <zj-camera-preview
                      ref="childOneVideo"
                      class="videoBig-item"
                      :cameraId="cameras[0].cameraId"
                      :cameraName="cameras[0].cameraName"
                      :autoplay="autoplay"
                      :streamType="streamType"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 分屏是一个的时候结束 -->
            <!-- 分屏是3个 -->
            <div class="threes" v-if="showtype == '3'">
              <div class="leftBigVideo">
                <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="cameras[0].cameraId"
                  :cameraName="cameras[0].cameraName"
                  :autoplay="autoplay"
                  :streamType="streamType"
                />
              </div>
              <div class="rightVideo">
                <div class="rightbottomvideo">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[1].cameraId"
                    :cameraName="cameras[1].cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
                <div class="rightbottomvideo">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[2].cameraId"
                    :cameraName="cameras[2].cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </div>
            </div>
            <!-- 分屏是3个结束 -->
            <!-- 分屏是4个，第一种开始 &&showtypeIndex=='2'-->
            <div
              class="threes averaBox"
              v-if="showtype == '4' && showtypeIndex == '2'"
            >
              <template v-for="(item, index) in cameras">
                <div
                  class="righttopvideo"
                  :key="index"
                  :class="{ martop12: index > 1 }"
                  @mouseover="mouseOver(index)"
                  @mouseleave="mouseLeave(index)"
                >
                  <div
                    class="closebtn"
                    @click="closeNowVideo(index)"
                    v-show="item.showClose"
                  ></div>
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是4个，第一种结束 -->
            <!-- 分屏是4个，第二种开始 -->
            <div class="threes" v-if="showtype == '4' && showtypeIndex == '3'">
              <div class="leftBigVideo">
                <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="cameras[0].cameraId"
                  :cameraName="cameras[0].cameraName"
                  :autoplay="autoplay"
                  :streamType="streamType"
                />
              </div>
              <div class="rightVideo">
                <div class="rightvideo3">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[1].cameraId"
                    :cameraName="cameras[1].cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
                <div
                  class="rightvideo3"
                  style="margin-top:1rem;margin-bottom:1rem;"
                >
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[2].cameraId"
                    :cameraName="cameras[2].cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
                <div class="rightvideo3">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[3].cameraId"
                    :cameraName="cameras[3].cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </div>
            </div>
            <!-- 分屏是4个，第二种结束 -->
            <!-- 分屏是6个，第1种开始 -->
            <div
              class="threes averaBox"
              v-if="showtype == '6' && showtypeIndex == '4'"
            >
              <div
                class="videoSix"
                v-for="(item, index) in cameras"
                :key="index"
              >
                <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="item.cameraId"
                  :cameraName="item.cameraName"
                  :autoplay="autoplay"
                  :streamType="streamType"
                />
              </div>
            </div>
            <!-- 分屏是6个，第1种结束 -->
            <!-- 分屏是6个，第2种开始 -->
            <div
              class="threes averaBox"
              v-if="showtype == '6' && showtypeIndex == '5'"
            >
              <div
                class="videoSixtop"
                :class="{ videoSixtop: index < 2, videoSixbottom: index > 1 }"
                v-for="(item, index) in cameras"
                :key="index"
              >
                <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="item.cameraId"
                  :cameraName="item.cameraName"
                  :autoplay="autoplay"
                  :streamType="streamType"
                />
              </div>
            </div>
            <!-- 分屏是6个，第二种结束 -->
            <!-- 分屏是7个 -->
            <div class="threes averaBox" v-if="showtype == '7'">
              <div class="leftBigVideo">
                <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="cameras[0].cameraId"
                  :cameraName="cameras[0].cameraName"
                  :autoplay="autoplay"
                  :streamType="streamType"
                />
              </div>
              <div class="rightVideo averaBox">
                <template v-for="(item, index) in cameras">
                  <div class="rightvideo7" v-if="index != 0" :key="index">
                    <zj-camera-preview
                      class="videoBig-item"
                      :cameraId="item.cameraId"
                      :cameraName="item.cameraName"
                      :autoplay="autoplay"
                      :streamType="streamType"
                    />
                  </div>
                </template>
              </div>
            </div>
            <!-- 分屏是7个结束 -->
            <!-- 分屏是9个 第一种开始 &&showtypeIndex=='7'-->
            <div
              class="threes averaBox"
              v-if="showtype == '9' && showtypeIndex == '7'"
            >
              <template v-for="(item, index) in cameras">
                <div
                  class="rightvideo9"
                  :key="index"
                  @mouseover="mouseOver(index)"
                  @mouseleave="mouseLeave(index)"
                >
                  <div
                    class="closebtn"
                    @click="closeNowVideo(index)"
                    v-show="item.showClose"
                  ></div>
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是9个 第一种结束-->
            <!-- 分屏是9个，第2种开始 -->
            <div
              class="threes averaBox"
              v-if="showtype == '9' && showtypeIndex == '8'"
            >
              <div
                class="leftBigVideo"
                style="border:none !important;display:flex;flex-wrap:wrap;justify-content: space-between;"
              >
                <div
                  class="videoSixtop"
                  :class="{
                    videoNinetop: index == 0,
                    videoNinebottom: index == 1 || index == 2,
                  }"
                  v-for="(item, index) in cameras"
                  :key="index"
                >
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </div>
              <div class="rightVideo averaBox">
                <template v-for="(item, index) in cameras">
                  <div class="rightvideo7" v-if="index > 2" :key="index">
                    <zj-camera-preview
                      class="videoBig-item"
                      :cameraId="item.cameraId"
                      :cameraName="item.cameraName"
                      :autoplay="autoplay"
                      :streamType="streamType"
                    />
                  </div>
                </template>
              </div>
            </div>
            <!-- 分屏是9个，第二种结束 -->
            <!-- 分屏是12个 第一种开始-->
            <div
              class="threes averaBox"
              v-if="showtype == '12' && showtypeIndex == '9'"
            >
              <template v-for="(item, index) in cameras">
                <div
                  class="rightvideo12"
                  :key="index"
                  :class="{ martop12: index > 3 }"
                >
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是12个 第一种结束-->
            <!-- 分屏是12个 第二种开始-->
            <div
              class="threes averaBox"
              v-if="showtype == '12' && showtypeIndex == '10'"
            >
              <template v-for="(item, index) in cameras">
                <div
                  class="rightvideo12"
                  :key="index"
                  :class="{ martop12: index > 3 }"
                >
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是12个 第二种结束-->
            <!-- 分屏是15个 第1种开始-->
            <div
              class="threes averaBox"
              v-if="showtype == '15' && showtypeIndex == '11'"
            >
              <template v-for="(item, index) in cameras">
                <div
                  class="rightvideo15"
                  :key="index"
                  :class="{ martop12: index > 4 }"
                >
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是15个 第1种结束-->
            <!-- 分屏是15个 第2种开始-->
            <div
              class="threes averaBox"
              v-if="showtype == '15' && showtypeIndex == '12'"
            >
              <template v-for="(item, index) in cameras">
                <div class="rightvideo9" :key="index" v-if="index < 3">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
                <div
                  class="rightvideomini"
                  :key="index"
                  :class="{ martop12: index > 2 }"
                  v-if="index > 2"
                >
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是15个 第2种结束-->
            <!-- 分屏是16个 第1种开始-->
            <div class="threes averaBox" v-if="showtype == '16'">
              <template v-for="(item, index) in cameras">
                <!-- :class="{'martop12':index>3}" -->
                <div class="rightvideo16" :key="index">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是16个 第1种结束-->
            <!-- 分屏是24个 第1种开始-->
            <div class="threes averaBox" v-if="showtype == '24'">
              <template v-for="(item, index) in cameras">
                <div class="rightvideo24" :key="index">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是24个 第1种结束-->
          </div>
          <div class="bottomContent">
            <!-- 左侧单个视频控制播放 v-if="cameras.length==1" :max="" -->
            <div class="changebofang">
              <div>
                轮播间隔(分钟)<el-input-number
                  style="margin-left:10px;"
                  v-model="num"
                  @change="handleChange"
                  :min="1"
                  label="描述文字"
                ></el-input-number>
              </div>
              <!--    -->
              <div
                style="width:19px;height:21px;margin-left:15px;"
                @click="changeVideo"
              >
                <img
                  style="width:100%;height:100%;"
                  src="../../../theme-default/src/images/zanting.png"
                  alt=""
                />
              </div>
              <div class="line"></div>
              <div style="width:21px;height:21px;" @click="stopOneVideo">
                <img
                  style="width:100%;height:100%;"
                  src="../../../theme-default/src/images/tingzhi.png"
                  alt=""
                />
              </div>
            </div>
            <!-- 右侧分屏数量 -->
            <div class="rightChange">
              <div class="changeLogo" @click="changeFenqi"></div>
              <div class="line" v-if="cameras.length == 1"></div>
              <div
                style="width:31px;height:22px;"
                @click="dbOneVideo"
                v-if="cameras.length == 1"
              >
                <img
                  style="width:100%;height:100%;"
                  src="../../../theme-default/src/images/fangda.png"
                  alt=""
                />
              </div>
            </div>
            <!-- 分屏弹窗 -->
            <ul class="fenpingBox" v-show="showFenqi">
              <li
                class="fenping_one"
                v-for="(item, index) in fenping"
                :key="index"
                @click="changeShowType(item.type, index)"
              >
                <img :src="item.src" alt="" />
                <div style="color:#bce1ee;font-size:14px;text-align:center;">
                  {{ item.type }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import ZJApp from "../../../../../app";
const ZJPlayer = ZJApp.ZJPlayer;
const MediaCenter = ZJPlayer.MediaCenter;
// const MSG = ZJPlayer.MediaCenterMsg;
// const PageSize = 100;
// eslint-disable-next-line no-unused-vars
import MyApis from "../../../apis";
import src1 from "../../../theme-default/src/images/1.png";
import src2 from "../../../theme-default/src/images/2.png";
import src3 from "../../../theme-default/src/images/3.png";
import src4 from "../../../theme-default/src/images/4.png";
import src5 from "../../../theme-default/src/images/5.png";
import src6 from "../../../theme-default/src/images/6.png";
import src7 from "../../../theme-default/src/images/7.png";
import src8 from "../../../theme-default/src/images/8.png";
import src9 from "../../../theme-default/src/images/9.png";
// eslint-disable-next-line no-unused-vars
import $ from "jquery";
export default {
  name: "swiperVideo",
  controller: "UI",
  action: "swiperVideo",
  data() {
    return {
      num: 1, //分钟数
      fenping: [
        { type: "1", src: src1 },
        { type: "3", src: src2 },
        { type: "4", src: src3 },
        { type: "4", src: src4 },
        { type: "6", src: src5 },
        { type: "6", src: src6 },
        { type: "7", src: src7 },
        { type: "9", src: src8 },
        { type: "9", src: src9 },
      ],
      isStart: true,
      valueJj: 20,
      valueCircle: 20,
      showFenqi: false,
      filterText: "",
      loading: false,
      loadingText: "",
      nodes: [],
      autoplay: true,
      defaultProps: {
        children: "children",
        label: "label",
      },
      previewPlayerConfigs: {
        streamType: 1, //0 - 主码流；1 - 子码流
        autoplay: false,
      },
      playbackPlayerConfigs: {
        streamType: 1, //0 - 主码流；1 - 子码流
        autoplay: false,
      },
      cameras: [
        {
          cameraId: "",
          cameraName: "",
        },
      ],
      selectPlayerIndex: 0,
      color: ["2ac1ff", "2ac1ff", "#2ac1ff", "2ac1ff", "2ac1ff", "2ac1ff"],
      mc: "",
      // Triangle:"",
      showtype: "1", //摆放几个视频
      showtypeIndex: 0,
      setVideo: "",
      nodeSwiper: [],
      treeClickCount: 0,
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    // this.search();
    this.searchGroups();
  },
  mounted() {
    this.$store.dispatch("submitIsShowbg", false);
    this.theme.sidemenu.visiable = false;
    this.mc = new MediaCenter();
    this.mc.on("connected", () => this.onConnected());
    this.mc.on("msg", (e) => this.onRecv(e));
    this.mc.on("error", (e) => this.onError(e));
    this.logInfo.ActionName = "视频轮播查看";
    this.logInfo.LogMessage = "视频轮播查看";
    this.logInfo.ModuleName = "视频监控";
    this.logInfo.PageName = "视频轮播页面";
    this.addOperationLog();
  },
  methods: {
    ...mapActions(["submitIsShowbg"]),
    dbOneVideo() {
      // 全屏
      this.$refs.childOneVideo.onDblClick();
    },
    changeVideo() {
      let that = this;
      let showtype = Number(this.showtype);
      let nodeArr = this.nodeSwiper;
      let sliceTimes = parseInt(nodeArr.length / showtype);
      let yuTimes = nodeArr.length % showtype;
      if (yuTimes == 0) {
        sliceTimes = sliceTimes - 1;
      }
      //  console.log(sliceTimes)
      //  console.log(yuTimes)
      let changeTime = this.num * 60 * 1000;
      let i = 0;
      that.startOneVideo(i);
      this.setVideo = setInterval(function() {
        i++;
        if (i > sliceTimes) {
          i = 0;
        }
        that.startOneVideo(i);
      }, changeTime);
    },
    startOneVideo(i) {
      // 开始播放视频
      // this.$refs.childOneVideo.play();
      let that = this;
      let showtype = Number(this.showtype);
      let nodeArr = this.nodeSwiper;
      let swiperArr = nodeArr.slice(i * showtype, (i + 1) * showtype);
      for (let j = 0; j < swiperArr.length; j++) {
        if (this.cameras && this.cameras[this.selectPlayerIndex]) {
          that.cameras[j].cameraId = swiperArr[j].id;
          that.cameras[j].cameraName = swiperArr[j].label;
          that.selectPlayerIndex = (that.selectPlayerIndex + 1) % showtype;
        }
      }
    },
    stopOneVideo() {
      // 停止播放视频
      // this.$refs.childOneVideo.stop();
      let that = this;
      clearInterval(that.setVideo);
    },

    changeShowType(type, index) {
      // 改变视频显示个数
      this.showtype = type;
      this.showtypeIndex = index;
      let showtype = Number(this.showtype);
      console.log("showtype");
      console.log(showtype);
      let length = this.cameras.length;
      if (length <= showtype) {
        let num = showtype - length;
        for (let i = 0; i < num; i++) {
          let obj = {
            cameraId: "",
            cameraName: "",
          };
          this.cameras.push(obj);
        }
      } else {
        this.cameras.splice(showtype);
      }
      console.log("this.cameras");
      console.log(this.cameras);
      this.showFenqi = false;
    },
    searchGroups() {
      new MyApis.SwiperVideoApi()
        .GetGroups()
        .then((r) => {
          console.log("1");
          console.log(r);
          r = r.data.Data;
          this.nodes = this.convertToTreeNodesGroup(r);
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    search() {
      let that = this;
      new MyApis.EquipmentApi()
        .GetRegionEquipment({
          EquipmentType: "Monitor",
        })
        .then((r) => {
          r = r.data.Data;
          // console.log(r);
          this.nodes = that.convertToTreeNodesfunction(r);
        })
        .catch((e) => {
          console.error(e);
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索视频失败！",
            type: "error",
          });
        });
    },
    convertToTreeNodesGroup(list) {
      let result = [];
      for (let i = 0; i < list.length; i++) {
        var regionData = list[i];
        var region = {
          id: regionData.GroupId,
          label: regionData.GroupName,
          children: [],
        };

        if (!regionData.Items) continue;
        for (let j = 0; j < regionData.Items.length; j++) {
          var deviceData = regionData.Items[j];
          region.children.push({
            id: deviceData.ItemId,
            label: deviceData.ItemName,
            children: [],
          });
        }
        result.push(region);
      }
      // console.log("result")
      // console.log(result)
      return result;
    },
    convertToTreeNodesfunction(list) {
      let result = [];
      for (let i = 0; i < list.length; i++) {
        var regionData = list[i];
        var region = {
          id: regionData.RegionId,
          label: regionData.RegionName,
          children: [],
        };

        if (!regionData.Devices) continue;
        for (let j = 0; j < regionData.Devices.length; j++) {
          var deviceData = regionData.Devices[j];
          region.children.push({
            id: deviceData.DeviceId,
            label: deviceData.DeviceName,
            children: [],
          });
        }
        result.push(region);
      }
      return result;
    },
    // eslint-disable-next-line no-unused-vars
    nodeClick: function(data, node, self) {
      //记录点击次数
      this.treeClickCount++;
      //单次点击次数超过2次不作处理,直接返回,也可以拓展成多击事件
      if (this.treeClickCount >= 2) {
        return;
      }
      //计时器,计算300毫秒为单位,可自行修改
      this.timer = window.setTimeout(() => {
        if (this.treeClickCount == 1) {
          //把次数归零
          this.treeClickCount = 0;
        } else if (this.treeClickCount > 1) {
          //把次数归零
          this.treeClickCount = 0;
          //双击事件
          let showtype = Number(this.showtype);
          if (node.level == 1) {
            this.nodeSwiper = data.children;
          }
          if (node.level == 2) {
            if (this.cameras && this.cameras[this.selectPlayerIndex]) {
              this.cameras[this.selectPlayerIndex].cameraId = data.id;
              this.cameras[this.selectPlayerIndex].cameraName = data.label;
              this.selectPlayerIndex = (this.selectPlayerIndex + 1) % showtype;
            }
          }
        }
      }, 300);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    onBack: function() {
      this.$emit("handlerclose");
    },
    changeFenqi() {
      this.showFenqi = !this.showFenqi;
    },
    // 成功连接到媒体中心
    onConnected() {
      console.log("链接成功");
    },
    // 接收到媒体中心的响应
    onRecv(e) {
      console.log("回应");
      console.log(e);
    },
  },
  beforeDestroy() {
    this.$store.dispatch("submitIsShowbg", true);
    this.theme.sidemenu.visiable = true;
  },
};
</script>

<style scoped>
.leftNav {
  border: 1px solid #00bcfe;
  padding: 28px 20px;
  position: relative;
  background: #003669;
  width: 260px;
  display: flex;
  flex-direction: column;
  margin-right: 30px;
  box-sizing: border-box;
  overflow: scroll;
}
.leftSpot {
  width: 222px;
  height: 125px;
  background: url("../../../theme-default/src/images/guangxiao.png") no-repeat;
  position: absolute;
  left: -35px;
  top: -63px;
}
.leftNav_title {
  font-size: 22px;
  font-weight: bold;
  border-bottom: 1px solid #0ec0fe;
  color: #00bcfe;
  height: 40px;
  position: relative;
}
.nav-tree-filter {
  border-radius: 6px;
  border: solid 1px #00bcfe;
  margin-top: 45px;
  margin-bottom: 20px;
}
.title_btmLine {
  width: 47px;
  height: 7px;
  background-color: #28bbff;
  position: absolute;
  bottom: -3.5px;
  left: 17px;
}
.rightContent {
  padding: 20px;
  box-sizing: border-box;
  border: solid 1px #00bcfe;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.topContent {
  flex: 1;
  overflow: hidden;
  width: 100%;
  margin-bottom: 20px;
}
.bottomContent {
  width: 100%;
  height: 93px;
  background-color: #003669;
  border-radius: 6px;
  border: solid 1px #00bcfe;
  position: relative;
}

/* 选择一个视频 */
.oneVideoBox {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}
/* 左侧展示视频 */
.showOneVideo {
  flex: 1;
  height: 100%;
  background-color: black;
  border: solid 1px #00bcfe;
}
.controlOneVideo {
  width: 336px;
  height: 100%;
  background-color: #003669;
  border: solid 1px #00bcfe;
  position: relative;
  margin-left: 30px;
}
.videoOne {
  width: 100%;
  height: 100%;
}
.video-wrapper {
  width: 100%;
  height: 100%;
}

/* 滑块样式 */
.block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.zj_slider {
  width: 220px;
}
/* 选择分屏的样式 */
.changeLogo {
  width: 31px;
  height: 22px;
  background: url("../../../theme-default/src/images/fenping.png") no-repeat;
}
.fenpingBox {
  width: 200px;
  background-color: #003669;
  border: solid 1px #00bcfe;
  position: absolute;
  right: 1rem;
  bottom: 6rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 20px;
  z-index: 10000;
}
.fenping_one {
  list-style: none;
  margin-right: 10px;
  cursor: pointer;
}
.fenping_one img {
  width: 31px;
  height: 24px;
  margin-bottom: 8px;
}
.martop2 {
  margin-top: 15px;
}
/* 圆盘样式 */
.circleBox {
  width: 238px;
  height: 238px;
  border-radius: 50%;
  border: solid 2px #00bcfe;
  margin: 0 auto;
  margin-top: 40px;
  position: relative;
}
#wrap {
  width: 220px;
  height: 220px;
  position: absolute;
  left: 7px;
  top: 7px;
}
.sector {
  width: 100%;
  height: 100%;
  position: absolute;
  clip: rect(0 220px 110px 110px);
  overflow: hidden;
}
.inner,
.innerSelector {
  width: 100%;
  height: 100%;
  position: absolute;
  clip: rect(0 110px 220px 0);
  transform: rotate(45deg);
  text-align: left;
  border-radius: 50%;
  /* z-index: 1000; */
}
.inner::before {
  content: url("../../../theme-default/src/images/shang.png");
  position: absolute;
  top: 4px;
  right: 99px;
  z-index: 99;
  transform: rotate(-23deg);
}
.innerf {
  width: 100%;
  height: 100%;
  position: absolute;
  clip: rect(0 110px 220px 0);
  transform: rotate(90deg);
  text-align: left;
  border-radius: 50%;
  z-index: 1000;
}

.innerf::before {
  content: url("../../../theme-default/src/images/shang.png");
  position: absolute;
  top: 4px;
  right: 99px;
  z-index: 99;
  transform: rotate(-23deg);
}
.innerSelector::before {
  content: url("../../../theme-default/src/images/shang2.png");
  position: absolute;
  top: 4px;
  right: 99px;
  z-index: 99;
  transform: rotate(-23deg);
}
/* 小圆盘样式 */
.circleMini {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #116ea5;
  border: solid 1px #00bcfe;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -50px;
  margin-top: -50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fangstop {
  width: 30px;
  height: 30px;
  border-radius: 3px;
  background: #29c7ff;
}
.fangstart {
  width: 23px;
  height: 30px;
  background: url("../../../theme-default/src/images/start.png") no-repeat;
}
/* 三个视频 */
.threes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}
.leftBigVideo {
  flex: 1;
  height: 100%;
  border: solid 1px #00bcfe;
  margin-right: 20px;
}
.leftVideo {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.rightVideo {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.righttopvideo {
  height: 48%;
  width: 49%;
  border: solid 1px #00bcfe;
}
.rightbottomvideo {
  height: 49%;
  width: 100%;
  border: solid 1px #00bcfe;
}
.videoBig-item {
  width: 100%;
  height: 100%;
}
.rightvideo3 {
  height: 32%;
  width: 100%;
  border: solid 1px #00bcfe;
}
/* 6个平分的样式 */
.videoSix {
  width: 49%;
  height: 32%;
  border: solid 1px #00bcfe;
}
.averaBox {
  flex-wrap: wrap;
}
.videoSixtop {
  width: 49%;
  height: 48%;
  border: solid 1px #00bcfe;
}
.videoSixbottom {
  width: 23.5%;
  height: 49%;
  border: solid 1px #00bcfe;
  margin-top: 15px;
}
.rightvideo7 {
  width: 48%;
  height: 32%;
  border: solid 1px #00bcfe;
}
.rightvideo9 {
  width: 32%;
  height: 32%;
  border: solid 1px #00bcfe;
}
.videoNinetop {
  width: 100%;
  height: 48%;
  border: solid 1px #00bcfe;
}
.videoNinebottom {
  width: 49%;
  height: 49%;
  border: solid 1px #00bcfe;
  margin-top: 15px;
}
.rightvideo12 {
  width: 23%;
  height: 32%;
  border: solid 1px #00bcfe;
}
.martop12 {
  margin-top: 10px;
}
.rightvideo15 {
  width: 19%;
  height: 31%;
  border: solid 1px #00bcfe;
}
.rightvideomini {
  width: 15.5%;
  height: 32%;
  border: solid 1px #00bcfe;
}
.rightvideo16 {
  width: 24%;
  height: 24%;
  border: solid 1px #00bcfe;
}
.rightvideo24 {
  width: 15.5%;
  height: 24%;
  border: solid 1px #00bcfe;
}

.zj-demo-player-tree-device-tree .el-tree-node.is-current {
  background-color: rgba(7, 78, 133, 0.7);
}
.changebofang {
  display: flex;
  align-items: center;
  position: absolute;
  left: 39px;
  top: 34px;
}
.line {
  width: 2px;
  height: 26px;
  background: linear-gradient(90deg, #00bcfe 0%, #4ed1ff 100%);
  margin-left: 29px;
  margin-right: 29px;
  opacity: 0.4;
}
.rightChange {
  position: absolute;
  right: 30px;
  top: 34px;
  display: flex;
  align-items: center;
}
</style>
